import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { Checkbox, CheckboxProps } from '../../checkbox/Checkbox'
import { FormField } from '../FormField'

export type CheckboxFieldProps<T extends FieldValues = FieldValues> = Omit<
  CheckboxProps,
  'selected' | 'onClick'
> & {
  name: FieldPath<T>
}

export const CheckboxField = <T extends FieldValues = FieldValues>({
  name,
  ...checkboxProps
}: CheckboxFieldProps<T>) => {
  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, errorMessage }) => (
        <Checkbox
          labelStyle={{ color: 'var(--palette-blue-500)' }}
          {...checkboxProps}
          selected={!!value}
          onClick={() => onChange(!value)}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
